export * from "./Resizable/Resizable.js"

export const VERSION = BUILD.DATA.VERSION; // eslint-disable-line
